export default __webpack_public_path__ + "814a00e.png";